import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

const Batch = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} md={6} lg={3}>
    <TextField
      label="Batch"
      fullWidth
      value={moduleValues?.['Batch'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Batch']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default Batch
